/** @jsxImportSource @emotion/react */
import { Button, Typography } from '@quickbit/qb-design-system';
import { useState } from 'react';
import { useAsyncFn, useMount } from 'react-use';
import { EmptyContent, Header, Loading } from '../../components';
import { User } from '../../types';
import { fetchGroups, fetchPermissions, fetchUsers } from './api';
import { UserDetails } from './components/details';
import { UserSearch } from './components/search';

export const UserManagement = () => {
  const [selectedUser, setSelectedUser] = useState<User | 'new'>();
  const [{ value, loading, error }, fetchAll] = useAsyncFn(() =>
    Promise.all([fetchUsers(), fetchGroups(), fetchPermissions()])
  );

  useMount(() => fetchAll());

  if (loading) return <Loading loading={loading} />;

  return (
    <div>
      {error && (
        <>
          <Header>
            <Typography variant="subtitle">Users</Typography>
          </Header>
          <EmptyContent
            heading="Oops! It's empty."
            body="Something went wrong"
            action={
              <Button
                text="Try again"
                variant="primary"
                onClick={() => fetchAll()}
              />
            }
          />
        </>
      )}
      {value && (
        <>
          {!selectedUser && (
            <UserSearch users={value[0]} setSelectedUser={setSelectedUser} />
          )}
          {selectedUser && (
            <UserDetails
              user={selectedUser}
              roles={value[1]}
              permissions={value[2]}
              cancel={() => {
                setSelectedUser(undefined);
                void fetchAll();
              }}
            />
          )}
        </>
      )}
    </div>
  );
};
